import React, {useEffect} from "react";

import {observer} from "mobx-react";
import {Form, Input, Modal} from "antd";
import SelectCustom from "../../../../../shared/components/form/SelectCustom";
import {smartPosStore} from "../SmartPosStore";
import {diningTablesStore} from "../../../pos/diningTables/DiningTableStore";
import {vendorSmartPos} from "../../../../../common/constants/Constants";
import SelectStatus from "../../../../../shared/components/form/SelectStatus";
import {posStore} from "../../../pos/PosStore";
import {labelstore} from "../../../../products/label/LabelStore";
type FieldType = {
    vendor_name?: string;
    pos_name?: string;
    pos_id?: string;
    secret_key?: string;
    merchant_id?: string;
    status?: number | null;
};
const Popup = () => {
    const [form] = Form.useForm();
    useEffect(()=>{
        form.setFieldsValue({
            pos_name: smartPosStore.formDataSmartPos.pos_name,
            vendor_name: smartPosStore.formDataSmartPos.vendor_name,
            status: smartPosStore.formDataSmartPos.status,
            pos_id: smartPosStore.formDataSmartPos.data.pos_id,
            secret_key: smartPosStore.formDataSmartPos.data.secret_key,
            merchant_id: smartPosStore.formDataSmartPos.data.merchant_id,
            stauts: smartPosStore.formDataSmartPos.status,
        })
    },[form,smartPosStore.formDataSmartPos])
    return (
        <>
            <div className="modalAddEditDiningTable">
                <Modal
                    title={`${
                        smartPosStore.typeModal === "add"
                            ? "Thêm mới Smart Pos"
                            : "Chỉnh sửa Smart Pos"
                    }`}
                    open={smartPosStore.openModal}
                    footer={null}
                    onCancel={() => {
                        form.resetFields();
                        smartPosStore.formDataSmartPos.vendor_name = '';
                        smartPosStore.openModal = false;
                        smartPosStore.formDataSmartPos.status = null;
                    }}
                    // wrapClassName={`modalAddEditDiningTable ${smartPosStore.isLoadingBtn ? "disable" : ""} `}
                >
                    <Form
                        form={form}
                        onFinish={(values: any) => {
                            smartPosStore.formDataSmartPos.pos_name = values.pos_name;
                            smartPosStore.formDataSmartPos.vendor_name = values.vendor_name;
                            smartPosStore.formDataSmartPos.data.pos_id = values.pos_id;
                            smartPosStore.formDataSmartPos.data.secret_key = values.secret_key;
                            smartPosStore.formDataSmartPos.data.merchant_id = values.merchant_id;
                            smartPosStore.typeModal === "add" ? smartPosStore.createSmartPos({form}) : smartPosStore.updateSmartPos({form});
                        }}
                    >
                        <Form.Item<FieldType>
                            className="item-form"
                            label="Nhà cung cấp"
                            name="vendor_name"
                            rules={[
                                {
                                    required: true,
                                    message: "Vui lòng chọn trường này",
                                },
                            ]}
                        >
                            <SelectCustom
                                list={vendorSmartPos}
                                placeholder="Vui lòng chọn"
                                showSearch
                                onChange={(value: any, name?: any) => {
                                    smartPosStore.formDataSmartPos.vendor_name = value;
                                }}
                                selected={() => {
                                    return smartPosStore.formDataSmartPos.vendor_name || null;
                                }}
                                getLabel={(item: any) => item.name}
                            ></SelectCustom>
                        </Form.Item>

                        <Form.Item<FieldType>
                            className="item-form"
                            label="Tên máy"
                            name="pos_name"
                            rules={[
                                {required: true, message: "Vui lòng nhập vào trường này"},
                                {max: 255, message: "Tối đa 255 ký tự"},
                                {
                                    validator: (_, value) => {
                                        if (value && !value.trim()) {
                                            return Promise.reject(
                                                new Error(
                                                    "Không được chỉ có khoảng trắng"
                                                )
                                            );
                                        }
                                        const specialCharPattern = /[#!@$%^&*]/;
                                        if (specialCharPattern.test(value)) {
                                            return Promise.reject(
                                                new Error(
                                                    "Không được chứa ký tự đặc biệt như: #!@$%^&*"
                                                )
                                            );
                                        }
                                        return Promise.resolve();
                                    },
                                },
                            ]}
                        >
                            <Input placeholder="Vui lòng nhập"/>
                        </Form.Item>

                        <Form.Item<FieldType>
                            className="item-form"
                            label="POS ID"
                            name="pos_id"
                            rules={[
                                {required: true, message: "Vui lòng nhập vào trường này"},
                                {max: 255, message: "Tối đa 255 ký tự"},
                                {
                                    validator: (_, value) => {
                                        if (value && !value.trim()) {
                                            return Promise.reject(
                                                new Error(
                                                    "Không được chỉ có khoảng trắng"
                                                )
                                            );
                                        }
                                        const specialCharPattern = /[#!@$%^&*]/;
                                        if (specialCharPattern.test(value)) {
                                            return Promise.reject(
                                                new Error(
                                                    "Không được chứa ký tự đặc biệt như: #!@$%^&*"
                                                )
                                            );
                                        }
                                        return Promise.resolve();
                                    },
                                },
                            ]}
                        >
                            <Input placeholder="Vui lòng nhập"/>
                        </Form.Item>

                        <Form.Item<FieldType>
                            className="item-form"
                            label="Secret key"
                            name="secret_key"
                            rules={[
                                {required: true, message: "Vui lòng nhập vào trường này"},
                                {max: 255, message: "Tối đa 255 ký tự"},
                                {
                                    validator: (_, value) => {
                                        if (value && !value.trim()) {
                                            return Promise.reject(
                                                new Error(
                                                    "Không được chỉ có khoảng trắng"
                                                )
                                            );
                                        }
                                        const specialCharPattern = /[#!@$%^&*]/;
                                        if (specialCharPattern.test(value)) {
                                            return Promise.reject(
                                                new Error(
                                                    "Không được chứa ký tự đặc biệt như: #!@$%^&*"
                                                )
                                            );
                                        }
                                        return Promise.resolve();
                                    },
                                },
                            ]}
                        >
                            <Input placeholder="Vui lòng nhập"/>
                        </Form.Item>

                        <Form.Item<FieldType>
                            className="item-form"
                            label="Merchant ID"
                            name="merchant_id"
                            rules={[
                                {required: true, message: "Vui lòng nhập vào trường này"},
                                {max: 255, message: "Tối đa 255 ký tự"},
                                {
                                    validator: (_, value) => {
                                        if (value && !value.trim()) {
                                            return Promise.reject(
                                                new Error(
                                                    "Không được chỉ có khoảng trắng"
                                                )
                                            );
                                        }
                                        const specialCharPattern = /[#!@$%^&*]/;
                                        if (specialCharPattern.test(value)) {
                                            return Promise.reject(
                                                new Error(
                                                    "Không được chứa ký tự đặc biệt như: #!@$%^&*"
                                                )
                                            );
                                        }
                                        return Promise.resolve();
                                    },
                                },
                            ]}
                        >
                            <Input placeholder="Vui lòng nhập"/>
                        </Form.Item>

                        <Form.Item<FieldType>
                            className="item-form"
                            label="Trạng thái"
                            name="status"
                            rules={[{required: true, message: 'Vui lòng chọn trường này'}]}
                        >
                            <SelectStatus
                                onChange={(value: any) => {
                                    smartPosStore.formDataSmartPos.status = value;
                                }}
                                selected={() => smartPosStore.formDataSmartPos.status}
                                textOn="Hoạt động"
                                textOff="Ngưng hoạt động"
                            />
                        </Form.Item>



                        <div className="btnCreateModal">
                            <button
                                className="cancelModal"
                                type="button"
                                onClick={() => {
                                    form.resetFields();
                                    smartPosStore.formDataSmartPos.vendor_name = '';
                                    smartPosStore.openModal = false;
                                    smartPosStore.formDataSmartPos.status = null;
                                }}
                            >
                                Hủy bỏ
                            </button>
                            <button
                                className={`submitForm`}
                                // disabled={smartPosStore.isLoadingBtn}
                                type="submit"
                            >
                                {smartPosStore.typeModal === "add" && !smartPosStore.isSave
                                    ? "Thêm mới"
                                    : smartPosStore.typeModal === "edit" &&
                                    !smartPosStore.isSave
                                        ? "Cập nhật"
                                        : "Vui lòng chờ..."}
                            </button>
                        </div>
                    </Form>
                </Modal>
            </div>
        </>
    )
}
export default observer(Popup)